
class SalesBannerRenderer {
  constructor(options = {}) {
    this.settings = {
      imageSizes: `(max-width: 767px) calc(100vw - 3rem), calc(((min(1440px, 100vw) * 0.585) - 4.5rem) / 1)`,
      imageWidths: '400, 620, 690, 810, 980, 1240, 1380, 1620, 1960',
      mobileImageWidths: '400, 600',
      phabletImageWidths: '620, 690, 810',
      ...options,
    };

    this.strings = {
      actionButtonDefault: 'Shop Now'
    };
  }

  render(data,pos,source) {
    const bannerOnly = data.bannerOnly || (!data.topText && !data.centralText && ! data.actionButtonText);
    const link = this.generateHref(data,pos,source);
    const containerTag = bannerOnly && link ? 'a' : 'div';

    return `
      <${containerTag} 
        class='sales-banner hover-wrapper${bannerOnly ? ' sales-banner--banner-only' : ''}${!bannerOnly && data.contentPosition ? ` sales-banner--${data.contentPosition.toLowerCase().replaceAll(' ','-')}` : ''}'
        ${bannerOnly && link ? ` href="${link}"` : ''}>
        ${bannerOnly ? '' : this.renderTopSection(data.topText)}
        ${bannerOnly ? '' : this.renderCentralSection(data.centralText)}
        ${bannerOnly ? '' : this.renderCallToAction(link,data.actionButtonText)}
        ${this.renderImageWrapper(data)}
      </${containerTag}>
    `;
  }

  renderTopSection(topHtml) {
    if (!topHtml) return '';
    return `
      <div class="sales-banner__top-section">
        ${topHtml}
      </div>
    `;
  }

  renderCentralSection(centralHtml) {
    if (!centralHtml) return '';
    return `
      <div class="sales-banner__central-section">
        ${centralHtml}
      </div>
    `;
  }

  renderCallToAction(link,text) {
    if (!link) return '';
    return `
      <div class="sales-banner__bottom-section">
        <a href="${link}" class="btn btn--primary">
          <span class="btn__text">${text || this.strings.actionButtonDefault}</span>
        </a>
      </div>
    `;
  }

  renderImageWrapper(data) {
    if (!data.imageUrl) return `
      <div class="sales-banner__background-wrapper no-image"></div>
    `;
    return `
      <div class="sales-banner__background-wrapper">
        <motion-element data-motion="zoom-out-sm">
          <picture class="media-wrapper sales-banner__image-wrapper">
            ${this.renderMobileSource(data.mobileImageUrl,data.mobileImageWidth,data.mobileImageHeight)}
            ${this.renderPhabletSource(data.phabletImageUrl,data.phabletImageWidth,data.phabletImageHeight)}
            ${this.renderImage(data.imageUrl,data.imageWidth,data.imageHeight,data.imageAlt)}
          </picture>
        </motion-element>
      </div>
    `;
  }

  renderImage(url,width,height,alt) {
    const imageUrl = this.generateImageUrl(url, width);
    const srcset = this.generateSrcset(url, width, this.settings.imageWidths);

    return `
      <img
        class="motion-reduce hover-scale-up sales-banner__image"
        src="${imageUrl}"
        alt="${this.escapeHtml(alt || '')}"
        srcset="${srcset}"
        width="${width}"
        height="${height}"
        loading="lazy"
        fetchpriority="low"
        sizes="${this.settings.imageSizes}"
        is="image-lazy"
        draggable="false"
      />
    `;
  }

  renderMobileSource(url,width,height) {
    if (!url) return '';

    const srcset = this.generateSrcset(url, width, this.settings.mobileImageWidths);

    return `
      <source
        media="(max-width: 480px)"
        srcset="${srcset}"
        width="${width}"
        height="${height}"
      />
    `;
  }

  renderPhabletSource(url,width,height) {
    if (!url) return '';

    const srcset = this.generateSrcset(url, width, this.settings.phabletImageWidths);

    return `
      <source
        media="(min-width: 640px) and (max-width: 767.98px)"
        srcset="${srcset}"
        width="${width}"
        height="${height}"
      />
    `;
  }

  generateImageUrl(baseUrl, width) {
    //urls in relative format, cannot use URL class - using simple workaround
    return `${baseUrl}${baseUrl.includes('?') ? '&' : '?'}width=${width}`;
  }

  generateSrcset(baseUrl, maxWidth, imageWidths) {
    const widths = imageWidths.split(', ').map(w => parseInt(w.trim()));
    const existingQuery = baseUrl.includes('?');
    return widths
      .filter(width => width <= maxWidth)
      .map(width => `${baseUrl}${existingQuery ? '&' : '?'}width=${width} ${width}w`)
      .join(', ');
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  generateHref(data,pos,source) {
    let link = data.actionButtonLink;
    if (!link) return;
    if (!data.addUtmTags) return link;
    try {
      link = new URL(link);
      if (source) link.searchParams.set('utm_source',source);
      link.searchParams.set('utm_medium','banner');
      if (data.utmCampaign) link.searchParams.set('utm_campaign',data.utmCampaign);
      if (data.utmCreative) link.searchParams.set('utm_creative',data.utmCreative);
      if (pos) link.searchParams.set('utm_position',pos);
      return link.toString();
    } catch(e) {
      console.error('Error adding UTM tags to sales banner link:',e);
      return data.actionButtonLink;
    }
  }
}

// Export for use
window.SalesBannerRenderer = SalesBannerRenderer;